export default "__VITE_ASSET__BvOpzOy0__"